import { Sparkles } from 'lucide-react';
import AIChat from '@/propertyai/components/AIChat';

export default function AIModePage() {
  return (
    <div className="h-[calc(100vh-56px)] flex bg-background">
      {/* Context sidebar */}
      <div className="hidden lg:flex w-[280px] border-r border-border bg-background flex-col p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h2 className="font-semibold text-sm">PropertyAI</h2>
            <p className="text-xs text-muted-foreground">AI Real Estate Advisor</p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <h3 className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">What I can help with</h3>
            <ul className="space-y-1.5 text-sm text-muted-foreground">
              <li>Search properties naturally</li>
              <li>Property valuations</li>
              <li>Affordability analysis</li>
              <li>Neighborhood insights</li>
              <li>Rent vs. buy analysis</li>
              <li>Offer competitiveness</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Markets Covered</h3>
            <div className="flex flex-wrap gap-1">
              {['Austin', 'Miami', 'Denver', 'Seattle', 'Phoenix', 'Nashville', 'Raleigh', 'Tampa', 'Charlotte', 'Portland'].map(city => (
                <span key={city} className="text-xs bg-secondary rounded-full px-2 py-0.5">{city}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-auto">
          <p className="text-xs text-muted-foreground">
            Powered by GPT-4o with real property data.
            Estimates are for informational purposes only.
          </p>
        </div>
      </div>

      {/* Chat */}
      <div className="flex-1 bg-background">
        <AIChat isOpen={true} onClose={() => {}} isFullScreen={true} context={{}} />
      </div>
    </div>
  );
}

